export const createContactsRoutes = (basePath: string) =>
  ({
    index: basePath,
    import: `${basePath}/import`,
    importPastUploads: `${basePath}/import/past-uploads`,

    newPerson: `${basePath}/people/new`,
    newCompany: `${basePath}/companies/new`,

    person: (id: string) => `${basePath}/people/${id}`,
    editPerson: (id: string) => `${basePath}/people/${id}/edit`,

    company: (id: string) => `${basePath}/companies/${id}`,
    editCompany: (id: string) => `${basePath}/companies/${id}/edit`,
  }) as const;
